import React, { Component } from 'react'

// This component will catch any errors in any of its children
class ErrorBoundary extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hasError: false,
    }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    //console.error(error)
    console.log(info)
  }

  // TODO: maybe pass a prop for each component, either `important` or not, and if the module is like, important for the user, we should render some error UI, if its not important, (like some extra tray) we can just render nothing?
 render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
